import Grid from '@material-ui/core/Grid';
import React from 'react';
import { useHistory } from 'react-router';

import { BackHeader } from '../../../components/common/backheader/BackHeader.component';
import { MogulLive } from '../../../components/mogul-live/MogulLive.component';
import { ModalStateContext } from '../../../contexts/app-state-context/modal-state.context';
import styles from './MogulLivePage.module.css';

export const MogulLivePage = () => {
  const history = useHistory();
  const { setModal } = React.useContext(ModalStateContext);

  const goBackToCommunityPage = () => {
    history.push('/platform/community-dashboard');
  };

  const video1 = {
    title: 'Mogul Live X Jordan Ver Hoeve',
    video: 'https://www.youtube.com/watch?v=9RbcokYrp9M',
    body: "James Pratt hosting live Q&As on Instagram with top Hollywood talent Jordan Ver Hoeve! You might recognize Jordan as Luke from Huge in France on Netflix. We'll be chatting with Jordan about how he got cast, some behind-the-scenes set stories, and his advice to actors on how they can best use technologies like Mogul to grow their careers. Have questions for Jordan? Need answers? Sign up to Mogul at www.mogulproductions.com and get rewarded for your participation 👏🏼 𝐈 𝐀𝐌 𝐌𝐎𝐆𝐔𝐋. 𝐖𝐄 𝐀𝐑𝐄 𝐌𝐎𝐆𝐔𝐋.",
    date: '23rd Apr 20',
  };
  const video2 = {
    title: 'Mogul Live x Dane Hallett',
    video: 'https://www.youtube.com/watch?v=3O6d_LsDqfY',
    body: 'Mogul Live with Tom Julian the Head of Television Studio JUL-TV! Tom is going to chat about running a TV studio, how the industry has changed and some of the best TV shows and current projects he is working on. How his network is handing the coronavirus and more!',
    date: '9th Apr 20',
  };
  const video3 = {
    title: 'Mogul Live x Tom Julian',
    video: 'https://www.youtube.com/watch?v=g60nAyNmh04',
    body: 'Mogul Live with Tom Julian the Head of Television Studio JUL-TV! Tom is going to chat about running a TV studio, how the industry has changed and some of the best TV shows and current projects he is working on. How his network is handing the coronavirus and more!',
    date: '7th May 20',
  };
  const video4 = {
    title: 'Mogul Live x Trisanne Marin',
    video: 'https://www.youtube.com/watch?v=0Oq63G2hoRw',
    body: 'Mogul Live with Trisanne Marin, a top 40 under 40 Hollywood Manager on her upcoming project Malibu Crush Movie and the biggest changes in Hollywood. and what it means for actors/actresses. Tips on how to find a good manager and how to succeed!',
    date: '12th May 20',
  };
  const video5 = {
    title: 'Mogul Live x Justin Levine',
    video: 'https://www.youtube.com/watch?v=aU3luiD_wXs',
    body: 'We went live on Mogul’s Instagram June 1st at 2PM pt / 5PM et with Justin Levine, Hollywood producer at Stardust Pictures and co-founder of CastCaller on his producer perspectives, film financing, how he got started and looking at projects from script level. Tips and advices for people wanting to be a film producer, his films and current projects 🔥',
    date: '1st Jun 20',
  };
  const video6 = {
    title: 'Mogul Live x Kathryn Courtney-Prior',
    video: 'https://www.youtube.com/watch?v=1wxhAfrzt_Y',
    body: 'We went live Mogul’s Instagram June 9st at 4PM pt / 7PM et with Kathryn Courtney-Prior @yaplat_casting , Manager at Yaplat Casting on her career in casting and starting Yaplat. Kathryn will chat with us about the casting process, advices for actors trying to get casted, Instagram casting, how and what she look for when she search for talent and much more!',
    date: '9th Jun 20',
  };
  const video7 = {
    title: 'Mogul Live x David Cormican',
    video: 'https://www.youtube.com/watch?v=do6LOBdmVY0',
    body: 'Producer David Cormican joins host James Pratt in the return of Mogul Live for Season 2! Recorded LIVE on Mogul’s Instagram (instagram.com/mogul.official) June 22nd at 2pm PST / 5pm EST with special guest David Cormican, Emmy Nominated Producer, President & Partner at Don Carmody Television, and Advisor at Mogul. David chats with host James Pratt about his career in producing, working with his team at DCTV, and touches on the many projects he has in development (some of which are taking him all the way to South Africa!). He also takes some questions from the community in this highly engaging conversation!',
    date: '6th Jul 21',
  };

  // TODO: have data stored in database for ease of access
  const liveVideoData = [
    video7,
    video6,
    video5,
    video4,
    video3,
    video2,
    video1,
  ];

  return (
    <div className={styles.mogulLivePage}>
      <BackHeader title="live" headerOnPress={goBackToCommunityPage} />
      <span className={styles.mogulLiveSeperator}>All</span>
      <Grid
        container
        spacing={0}
        direction="row"
        className={styles.mogulLiveContainer}
      >
        {liveVideoData.map(videoData => (
          <Grid item key={videoData.title}>
            <MogulLive
              setModal={setModal}
              title={videoData.title}
              video={videoData.video}
              body={videoData.body}
              date={videoData.date}
            />
          </Grid>
        ))}
      </Grid>
    </div>
  );
};
